import { IJsonQueryDistrict } from '../../../json_query';

export const unselectDistrict = (selectedDistricts: IJsonQueryDistrict[], id: number) => {
  return selectedDistricts.filter(district => district.id !== id);
};
